import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useRtl } from "@ryde/redux";
import { DrawerType, useDrawers } from "@ryde/shared";

import {
  CustomProductionToggleButtonStyled,
  ProduceButtonsPanelTopItemsWrapper,
} from "./produce-buttons.styled";

export const CustomProductionButton: FC = () => {
  const { t } = useTranslation();
  const { isRtl } = useRtl();

  const { openDrawer } = useDrawers();

  const onClick = (): void => {
    openDrawer({
      drawerProps: {
        type: DrawerType.CustomProduction,
      },
    });
  };

  return (
    <ProduceButtonsPanelTopItemsWrapper>
      <FramerTooltip content={t("produceButton.CUSTOM_PRODUCTION")}>
        <CustomProductionToggleButtonStyled onClick={onClick}>
          {t("produceButton.CUSTOM_PRODUCTION")}
          {isRtl && <PIC.ArrowSvg style={{ transform: "rotateY(180deg)" }} />}
          {!isRtl && <PIC.ArrowSvg />}
        </CustomProductionToggleButtonStyled>
      </FramerTooltip>
    </ProduceButtonsPanelTopItemsWrapper>
  );
};
